import script from "./BlockTermsOfUse.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTermsOfUse.vue?vue&type=script&setup=true&lang=js"

import "./BlockTermsOfUse.vue?vue&type=style&index=0&id=57c9fa92&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c9fa92"]])

export default __exports__